import React from "react";
import { string, number } from "prop-types";

const SearchIcon = ({ width = 20, height = 20 }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      enable-background="new 0 0 24 24"
      width={width}
      height={height}
    >
      <path
        fill="#DAA520"
        d="M18.031,16.617l4.283,4.282l-1.415,1.415l-4.282-4.283C15.024,19.308,13.042,20.003,11,20
        c-4.968,0-9-4.032-9-9s4.032-9,9-9s9,4.032,9,9C20.003,13.042,19.308,15.024,18.031,16.617z M16.025,15.875
        C17.294,14.57,18.003,12.82,18,11c0-3.868-3.133-7-7-7c-3.868,0-7,3.132-7,7c0,
        3.867,3.132,7,7,7c1.82,0.003,3.57-0.706,4.875-1.975
        L16.025,15.875z"
      />
    </svg>
  );
};

SearchIcon.propTypes = {
  color: string,
  width: number,
  height: number,
};

export default SearchIcon;
